<div class="grid-container-footer text-right float-right">
  <div class="position-relative display-inline-block">
    <button data-cy="cancel-personal-information-button" mat-flat-button class="mat-secondary btn position-relative" (click)="tab.data.onCancel()" [disabled]="tab.loading">
      <span class="lbl-count" id="btnCancel">{{ tab.data.cancelBtnLabel }}</span>
    </button>
  </div>
  @if (!tab.data.hideNext) {
    <div class="position-relative display-inline-block ml-4">
      <button
        [ngClass]="tab.data.submitBtnLabel.length > 6 ? 'btn-long' : ''"
        data-cy="submit-personal-information-button"
        mat-flat-button
        class="mat-primary btn"
        (click)="tab.data.onSubmit()"
        [disabled]="tab.data.disableNext || tab.data.form?.invalid || tab.loading || (!tab.data.isEdit && tab.data.form?.pristine)"
      >
        <span class="lbl-count" id="btnNext">
          {{ tab.data.submitBtnLabel }}
        </span>
        @if (tab.loading) {
          <mat-spinner class="small-loader" diameter="20" strokeWidth="2"></mat-spinner>
        }
      </button>
    </div>
  }
</div>
